import { ILeagues } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const LeaguesHPWrapper = React.lazy(() => import('./leagues-homepage'));
export interface IDynamicLeaguesHP extends IComponentModel<ILeagues> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicLeaguesHomepage = ({
  /* istanbul ignore next: default value */ model = {} as ILeagues,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicLeaguesHP) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <LeaguesHPWrapper live={live} initialModel={validateModel(model) as ILeagues} query={validateModel(query)} />
  </Suspense>
);

export default DynamicLeaguesHomepage;
